/**
 * Fase 17 · Helpers comunes del Libro de Control Fiduciario.
 */
export const SEMAFORO = {
    rojo: "bg-red-100 text-red-900 border-red-300",
    ambar: "bg-amber-100 text-amber-900 border-amber-300",
    verde: "bg-emerald-100 text-emerald-900 border-emerald-300",
    gris: "bg-muted text-muted-foreground border-muted",
};

export const SEMAFORO_LABEL = {
    rojo: "Vencido / Crítico",
    ambar: "Próximo a vencer",
    verde: "En plazo",
    gris: "Sin fecha",
};

export const CATEGORIA_LABEL = {
    dictamen_f09: "Dictámenes F-09",
    cotizacion: "Cotizaciones",
    poder: "Poderes",
    requerimiento: "Requerimientos autoridad",
    convenio: "Convenios modificatorios",
    sustitucion: "Sustituciones",
    contingencia: "Contingencia",
};

export const CM_ESTADOS = {
    propuesto: { label: "Propuesto", cls: "bg-slate-100 text-slate-800 border-slate-200 border" },
    en_dictamen: { label: "En dictamen", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
    en_firma: { label: "En firma", cls: "bg-sky-100 text-sky-900 border-sky-300 border" },
    vigente: { label: "Vigente", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    rechazado: { label: "Rechazado", cls: "bg-red-100 text-red-900 border-red-300 border" },
};

export const SF_ESTADOS = {
    notificada: { label: "Notificada", cls: "bg-slate-100 text-slate-800 border-slate-200 border" },
    en_entrega: { label: "En entrega", cls: "bg-sky-100 text-sky-900 border-sky-300 border" },
    completada: { label: "Completada", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    observada: { label: "Observada", cls: "bg-red-100 text-red-900 border-red-300 border" },
};

export const TER_ESTADOS = {
    propuesta: { label: "Propuesta", cls: "bg-slate-100 text-slate-800 border-slate-200 border" },
    en_liquidacion: { label: "En liquidación", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
    cerrada: { label: "Cerrada", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    observada: { label: "Observada", cls: "bg-red-100 text-red-900 border-red-300 border" },
};

export const POD_ESTADOS = {
    vigente: { label: "Vigente", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    por_vencer: { label: "Por vencer", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
    vencido: { label: "Vencido", cls: "bg-red-100 text-red-900 border-red-300 border" },
    revocado: { label: "Revocado", cls: "bg-slate-200 text-slate-700 border-slate-300 border" },
    sustituido: { label: "Sustituido", cls: "bg-slate-100 text-slate-700 border-slate-200 border" },
};

export const REQ_ESTADOS = {
    recibido: { label: "Recibido", cls: "bg-slate-100 text-slate-800 border-slate-200 border" },
    en_analisis: { label: "En análisis", cls: "bg-sky-100 text-sky-900 border-sky-300 border" },
    en_respuesta: { label: "En respuesta", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
    respondido: { label: "Respondido", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    impugnado: { label: "Impugnado", cls: "bg-red-100 text-red-900 border-red-300 border" },
    concluido: { label: "Concluido", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    archivado: { label: "Archivado", cls: "bg-slate-200 text-slate-700 border-slate-300 border" },
};

export const IC_ESTADOS = {
    registrada: { label: "Registrada", cls: "bg-amber-100 text-amber-900 border-amber-300 border" },
    conciliada: { label: "Conciliada", cls: "bg-emerald-100 text-emerald-900 border-emerald-300 border" },
    observada: { label: "Observada", cls: "bg-red-100 text-red-900 border-red-300 border" },
    anulada: { label: "Anulada", cls: "bg-slate-200 text-slate-700 border-slate-300 border" },
};

export const AUTORIDAD_LABEL = {
    cnbv: "CNBV", sat: "SAT", uif: "UIF",
    fiscalia_general: "Fiscalía General",
    juzgado_civil: "Juzgado Civil",
    juzgado_mercantil: "Juzgado Mercantil",
    judicial_federal: "Judicial Federal",
    judicial_estatal: "Judicial Estatal",
    laboral: "Laboral",
    otra: "Otra",
};

export const TIPO_POD_LABEL = {
    general_pleitos: "General Pleitos y Cobranzas",
    general_administracion: "General Administración",
    general_dominio: "General Dominio (requiere aprobación)",
    especial_ejecucion: "Especial Ejecución",
    especial_representacion_judicial: "Especial Representación Judicial",
    otro: "Otro",
};

export const TIPO_MOD_LABEL = {
    cambio_fines: "Cambio de fines",
    cambio_partes: "Cambio de partes",
    cambio_patrimonio: "Cambio de patrimonio",
    cambio_honorarios: "Cambio de honorarios",
    cambio_producto: "Cambio de producto",
    cambio_riesgo_pld: "Cambio riesgo PLD",
    cambio_plazo: "Cambio de plazo",
    cambio_comite_tecnico: "Cambio de comité técnico",
    otros_operativos: "Otros operativos",
};

export const CAUSAL_LABEL = {
    cumplimiento_fines: "Cumplimiento de los fines",
    vencimiento_plazo: "Vencimiento del plazo",
    imposibilidad: "Imposibilidad de realización",
    voluntad_partes: "Voluntad de las partes",
    revocacion: "Revocación",
    sentencia_judicial: "Sentencia judicial",
    otra: "Otra",
};

export const fmtMXN = (v) => {
    if (v === null || v === undefined || v === "") return "—";
    return new Intl.NumberFormat("es-MX", {
        style: "currency", currency: "MXN", maximumFractionDigits: 2,
    }).format(Number(v));
};

export const fmtFecha = (iso) => {
    if (!iso) return "—";
    try { return new Date(iso).toLocaleDateString("es-MX"); } catch { return iso; }
};

export const diasHasta = (iso) => {
    if (!iso) return null;
    const d = new Date(iso) - new Date();
    return Math.floor(d / 86400000);
};
